export default "__VITE_ASSET__0518ba86__"